import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import addCookieWithConsent from '../../pattern_utilities/addCookieWithConsent';

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// CREATE STRIPE CHECKOUT SESSION FOR UPGRADING TO PRO
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestCreateUserStripeCheckoutSession = packet => {
  return {
    type: 'REQUEST_CREATE_USER_STRIPE_CHECKOUT_SESSION',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveCreateUserStripeCheckoutSessionSuccess = data => ({
  type: 'RECEIVE_CREATE_USER_STRIPE_CHECKOUT_SESSION_SUCCESS',
  data
})

export const receiveCreateUserStripeCheckoutSessionFail = data => ({
  type: 'RECEIVE_CREATE_USER_STRIPE_CHECKOUT_SESSION_FAIL',
  data
})

export const tryToCreateUserStripeCheckoutSession = packet => dispatch => {
  dispatch(requestCreateUserStripeCheckoutSession(packet));
  
  return fetch('/api/users/create-checkout-session', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer " + Cookies.get(process.env.REACT_APP_COOKIE_AUTH)
      }
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      window.location.href = json.url;
      dispatch(receiveCreateUserStripeCheckoutSessionSuccess(json));
    })
    .catch(e => {
      revokeTokenHandler(e);
      return dispatch(receiveCreateUserStripeCheckoutSessionFail({errors:e, lastSubmit: packet}));
    })
}



// WEBPACK FOOTER //
// ./src/actions/user/a.u.POST.create-checkout-session.js